import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('api', 'workspace-filtros/{entidade}');

const workspaceFiltrosActions = {
  pesquisar: { method: 'GET', url: `${basePath}` },
  pesquisarPorIdEntidade: { method: 'GET', url: `${basePath}?idEntidade={idEntidade}` },
  inserir: { method: 'POST', url: `${basePath}` },
  atualizar: { method: 'PUT', url: `${basePath}` },
};

export default resource => resource(`${basePath}`, {}, workspaceFiltrosActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/workspace-filtros.js